export enum DocumentType {
    Inquiry,
    Offer,
    PurchaseOrder,
    SalesOrder,
    Demand,
    DemandAccount,
    Invoice,
    Credit,
    Contact,
    Product,
    Supplier,
    Customer,
}
